/**
 * قواعد الصور ومساعداتها — ملفٌّ بلا مكوّنات.
 * الثوابت والدوال منفصلة عن المكوّنات عمداً: خلطهما يكسر إعادة التحميل الساخن،
 * وهذه القيم يشاركها أكثر من شاشة (الشعار والألبوم وصور الطلبة والمهنيين).
 */

/** الأنواع المسموحة والحدّ الأقصى — مطابقة لما يفحصه الخادم (FILE-002 · FILE-003) */
export const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const;
export const IMAGE_ACCEPT = '.png,.jpg,.jpeg,.webp,image/png,image/jpeg,image/webp';
export const MAX_IMAGE_BYTES = 3 * 1024 * 1024;
export const IMAGE_RULE_HINT = 'PNG أو JPEG أو WebP، وبحدّ أقصى 3 ميغابايت.';

/** فحص محلّي يسبق الرفع — يوفّر رحلةً للخادم ويقول السبب بنفس لغة رسائله */
export function imageFileProblem(file: File): string | null {
  if (!(IMAGE_TYPES as readonly string[]).includes(file.type)) {
    return 'نوع الملف غير مدعوم — الصور المسموحة PNG و JPEG و WebP (FILE-003).';
  }
  if (file.size > MAX_IMAGE_BYTES) {
    return 'حجم الملف أكبر من الحدّ المسموح (3 ميغابايت) — اختر صورة أصغر (FILE-002).';
  }
  return null;
}

/**
 * رابط الموقع على الخريطة — رابطٌ لا خريطةٌ مُضمَّنة.
 * لا مكتبة خرائط ولا بلاطات ولا سكربت خارجي: الصفحة تعمل دون شبكة خارجية،
 * ومن أراد الخريطة فتحها في تطبيقه.
 *
 * 18 سبتمبر 2026 — خرائط جوجل بطلبٍ من صاحب المنصة: هي ما يفتحه الناس هنا،
 * ورابطُ `?q=lat,lng` يعمل في المتصفّح وفي التطبيق على الهاتف بلا مفتاح ولا حساب.
 */
export function mapLink(latitude: number, longitude: number): string {
  const lat = latitude.toFixed(6);
  const lng = longitude.toFixed(6);
  return `https://www.google.com/maps?q=${lat},${lng}`;
}

/** النطاقان المسموحان — الخادم يفحصهما أيضاً، والفحص هنا يمنع رحلةً فاشلة */
export function coordProblem(lat: string, lng: string): string | null {
  const bothEmpty = lat.trim() === '' && lng.trim() === '';
  if (bothEmpty) return null;
  if (lat.trim() === '' || lng.trim() === '') {
    return 'حدّد خط العرض وخط الطول معاً — أحدهما وحده لا يحدّد موقعاً (INST-GEO-001).';
  }
  const a = Number(lat);
  const b = Number(lng);
  if (!Number.isFinite(a) || a < -90 || a > 90) return 'خط العرض رقم بين ‎-90 و‎90.';
  if (!Number.isFinite(b) || b < -180 || b > 180) return 'خط الطول رقم بين ‎-180 و‎180.';
  return null;
}
